export default API => ({
  getRegionList(params) {
    return API({url: '/gx-homemaking/v1/region/getRegionList',params});
  },
  
  // 判断是否是培训机构管理员
  isAdmin(){
    return API({ url: '/usercenter/v1/administrator/isAdmin'}); 
  },
  //门户登录
  postAccountLogin(data){
    return API({
      url: '/gx-homemaking/v1/platform/login',
      method: 'post',
      data
    });
  },
  /**
   * 获取验证码
   * @param { phone: 手机号 } param1
   * 响应数据data：  boolean   是否发送验证码成功，true 成功；false
   */
  getAuthCodePublic ({ params, data }) {
    return API({ url: 'gx-homemaking/v1/common/getAuthCodePublic', method: 'post', params, data });
  },
  saveCompany ({ params, data }) {
    return API({ url: '/gx-homemaking/v1/company/saveCompany', method: 'post', params, data });
  },


})
